import type { MaterialInfo } from "@rogue/rackbuilder"
import { RackOptions } from "../../../../RackTypes"
import { MaterialBuilder } from "../../builders/materialBuilder"
import { FMLMaterialStrategy } from "./fmlMaterialStrategy"
import { FMMaterialStrategy } from "./fmMaterialStrategy"

// Extends powerRack material builder with FT specific methods
export class FTMaterialBuilder extends MaterialBuilder {
  protected config
  
  constructor(config: RackOptions) {
    super(config)
    this.config = config
    
    // Override parent's strategy
    this.strategy = config.line === 'RM' 
      ? new FMMaterialStrategy(config)
      : new FMLMaterialStrategy(config)
  }
  
  public createMainMaterial(): MaterialInfo {
    const mainMaterial = this.createMainMaterialValue() 
    
    return {
      main     : mainMaterial,
      hardware : { material: this.config.hardware },
      pulley   : { material: 'stainless' },
    }
  }

  public createFrontUprightMaterial(): MaterialInfo {
    return {
      main     : { name: 'metal', material: 'stainless', color: '#ffffff' },
      hardware : { material: this.config.hardware },
    }
  }

  public createLatBarMaterial(): MaterialInfo {
    // Use pre-computed value from getLatPulldownMaterial() — avoids re-deriving from latBarSelection.
    return (this.config.materials?.latpulldown as MaterialInfo) || {}
  }
}